import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import Helmet from 'react-helmet'
import { Link, LinkIcon, GetStartedInput } from '../../components'
import Styles from './Partners.css'
import { orderBy } from 'lodash'
import config from '../../config'

@CSSModules(Styles)
export default class Partners extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  renderImageCells(arr, lbl) {
    return arr.map((partner)=>{
      const img = (
        <img
          styleName='logo'
          src={require(`../../../static/images/p_${partner.short_name}.jpg`)}
          alt={partner.long_name}
        />
      )
      return (
        <div
          styleName={lbl + '-cell'}
          key={partner.short_name}
        >
        { /* if there is a link, wrap the image in a link */
          partner.link ?
            (
              <Link to={partner.link} title={partner.long_name}>
                {img}
              </Link>
            ) :
            img
        }
        </div>
      )
    })
  }

  render() {
    const funderImages = this.renderImageCells(config.funders, 'funder')
    const partnersList = orderBy(config.partners, ['short_name'], ['asc'])
    const partnerImages = this.renderImageCells(partnersList, 'logo')

    return (
      <div styleName='page'>
        <div styleName='container'>
          <div styleName='container-inner'>
            <Helmet title='Partners'/>
            <div styleName='headline'>
              Partners
            </div>
            <div styleName='lede'>
              Thanks to the following organizations and businesses for helping
              spread the word about Gender Equality Funds. Together, we’re
              moving the needle on gender equality in the workplace.
            </div>
            <div styleName='tagline'>
              Interested in becoming a partner?
            </div>
            <div styleName='lede'>
             Contact Stefanie Spear, Communications Director
             &nbsp;
             &nbsp;
              <Link to={config.links.contactStefanie} xstrong={true}>
                Email<LinkIcon faclass='fa-envelope-o'/>
              </Link>
            </div>
            <div styleName='logos'>
              { funderImages }
              { partnerImages }
            </div>
          </div>
        </div>
        <GetStartedInput/>
      </div>
    )
  }
}
